// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] || chunkId) + "-" + {"223":"b6de56a839dcb149e728","678":"a0d3ae65dd8a2aec8ac1","843":"0d36588e6b0e5625e0f6","883":"1f614ce7b6896e764c8c"}[chunkId] + ".js";
};